import { nucleusConstants } from '@lifesize/nucleus';

export const isEscalated = (state: string) => state === nucleusConstants.GALAXY_CONFERENCE_STATE_ESCALATED;
export const isVMR = (type: string) => type === nucleusConstants.GALAXY_CONFERENCE_TYPE_VMR;
